/* eslint-disable */
import React, { type FC, useEffect, useMemo, useState } from 'react';
import { Flex, Link, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import cx from 'classnames';
import moment from 'moment/moment';
import { TripReplays } from './components/TripReplays/TripReplays';
import { AimFor8Performance } from './components/AimFor8Performance/AimFor8Performance';
import { TripPanelTab } from './types';
import { type DateRange, type Page, type TargetVessel, ToasterVariant, type TripJobPair } from '../../types';
import { Timestamp } from '../../services/Timestamp';
import { type OperationViewModel } from '../Map/types';
import { translate, translateAndFormat } from '../../constants/translation';
import { useDetectMobileScreenWidth } from '../../hooks/useDetectMobileScreenWidth';
import { isCurrentMonth } from '../../utils/date-utils';
import { useToaster } from '../../hooks/useToaster';
import { externalLinks } from '../../constants/constants';

export interface Props {
  isOpen: boolean;
  page: Page;
  onClose: () => void;
  setStartTimestamp: (timestamp: Timestamp) => void;
  setTimestamp: (timestamp: Timestamp) => void;
  onTargetVesselChange: (mmsi: string, vesselName: string) => void;
  setHoveredJob: (tripJobPair: TripJobPair) => void;
  operation: OperationViewModel;
  targetVessel: TargetVessel;
  playbackTimestamp: Timestamp;
}

const tabsMap: Record<number, TripPanelTab> = {
  0: TripPanelTab.Replays,
  1: TripPanelTab.AimFor8,
};

const TripsPanel: FC<Props> = ({
  isOpen,
  page,
  onClose,
  setStartTimestamp,
  setTimestamp,
  onTargetVesselChange,
  setHoveredJob,
  operation,
  targetVessel,
  playbackTimestamp,
}) => {
  const getDefaultDateRange = (timestamp: Timestamp): DateRange => {
    const date = (timestamp?.valueInMilliseconds ? timestamp : Timestamp.now()).toDate();

    if (isCurrentMonth(date)) {
      date.setMonth(date.getMonth() - 1);
    }

    const year = date.getFullYear();
    const month = date.getMonth();

    const from = new Date(year, month, 1);
    const to = new Date(year, month + 1, 0);

    return { from, to };
  };

  const [selectedTab, setSelectedTab] = useState(TripPanelTab.Replays);
  const [aimFor8WasOpened, setAimFor8WasOpened] = useState(false);
  const isMobileView = useDetectMobileScreenWidth();
  const [aimFor8DateRange, setAimFor8DateRange] = useState<DateRange>(getDefaultDateRange(playbackTimestamp));
  const showToast = useToaster();

  const onAimFor8TabClose = (): void => {
    if (targetVessel?.mmsi) {
      return;
    }
    setTimestamp(Timestamp.fromString(aimFor8DateRange.from.toDateString()));
    const formatted = moment(aimFor8DateRange.from).format('D MMMM YYYY');
    showToast({
      title: translateAndFormat('SHOWING_DATE', formatted),
      variant: ToasterVariant.Success,
    });
  };

  useEffect(() => {
    if (selectedTab === TripPanelTab.Replays && !isMobileView && aimFor8WasOpened) {
      onAimFor8TabClose();
    }
  }, [aimFor8DateRange?.from, selectedTab, isMobileView, aimFor8WasOpened]);

  const isAimFor8TabAccessible = useMemo(() => {
    return !targetVessel?.mmsi;
  }, [targetVessel?.mmsi]);

  const handleClose = (): void => {
    if (aimFor8WasOpened) {
      onAimFor8TabClose();
    }
    setSelectedTab(TripPanelTab.Replays);
    setAimFor8WasOpened(false);
    onClose();
  };

  useEffect(() => {
    if (!isAimFor8TabAccessible && selectedTab === TripPanelTab.AimFor8) {
      if (isMobileView) {
        handleClose();
      } else {
        setSelectedTab(TripPanelTab.Replays);
      }
    }
  }, [isAimFor8TabAccessible]);

  return (
    <Flex
      className={cx('trips-panel-container', {
        expanded: isOpen,
        'aim-for-eight-open': !isMobileView && selectedTab === TripPanelTab.AimFor8,
        'aim-for-eight-closed': !isMobileView && selectedTab !== TripPanelTab.AimFor8 && aimFor8WasOpened,
      })}
      flexDirection="column"
    >
      {isOpen && (
        <>
          {/*<Tabs*/}
          {/*  index={selectedTab}*/}
          {/*  onChange={index => {*/}
          {/*    const tabToOpen = tabsMap[index] ?? TripPanelTab.Replays;*/}
          {/*    setSelectedTab(tabToOpen);*/}
          {/*    if (tabToOpen === TripPanelTab.AimFor8) {*/}
          {/*      setAimFor8WasOpened(true);*/}
          {/*    }*/}
          {/*  }}*/}
          {/*>*/}
          {/*<TabList>*/}
          {/*  <Tab className="text-md-semibold">*/}
          {/*    <Text>{translate('REPLAYS_TAB')}</Text>*/}
          {/*  </Tab>*/}
          {/*  <Tab className="text-md-semibold" isDisabled={!isAimFor8TabAccessible}>*/}
          {/*    <Text>{translate('AIM_FOR_8_TAB')}</Text>*/}
          {/*  </Tab>*/}
          {/*</TabList>*/}
          {/*<TabPanels className="trips-panel-tab-container">*/}
          {/*  <TabPanel className="trip-replays-tab">*/}
          <TripReplays
            onClose={handleClose}
            setStartTimestamp={setStartTimestamp}
            setTimestamp={setTimestamp}
            page={page}
            onTargetVesselChange={onTargetVesselChange}
            setHoveredJob={setHoveredJob}
            operation={operation}
          />
          {/*    </TabPanel>*/}
          {/*    <TabPanel className="aim-for-8-tab">*/}
          {/*      {isAimFor8TabAccessible && (*/}
          {/*        <AimFor8Performance*/}
          {/*          operation={operation.key}*/}
          {/*          dateRange={aimFor8DateRange}*/}
          {/*          setDateRange={setAimFor8DateRange}*/}
          {/*          isOpen={selectedTab === TripPanelTab.AimFor8}*/}
          {/*        />*/}
          {/*      )}*/}
          {/*    </TabPanel>*/}
          {/*  </TabPanels>*/}
          {/*</Tabs>*/}
        </>
      )}
    </Flex>
  );
};

export default React.memo(TripsPanel);
